import { styled, Typography } from '@mui/material'

export const BoldText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.primary.main,
}))

export const LabelText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  lineHeight: `${theme.spacing(4)}`,
}))
